// src/pages/SessionTimeout.js

import React from "react";
import { useNavigate } from "react-router-dom";
import "./SessionTimeout.css";

const SessionTimeout = () => {
  const navigate = useNavigate();

  return (
    <div className="timeout-page">
      <div className="timeout-card">
        <h2 className="timeout-title">Session Timed Out</h2>

        <p className="timeout-message">
          Your session has expired.<br />
          Please sign in again to continue.
        </p>

        <div className="timeout-actions">    

          <button className="timeout-btn" onClick={() => navigate("/login")}>
            Sign In Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeout;
